<template>
<div>
    <b-modal ok-title="جستجو" cancel-title="انصراف" id="modal-1" title="جستجو" @ok="filterData()">
        <b-form-group id="input-group-2" label="وضعیت: " label-for="input-2">
            <MDDropdown v-bind:group="17" v-model="search.mdid17_type"></MDDropdown>
        </b-form-group>
        <b-form-group id="input-group-1" label="کد مشتری: " label-for="input-1">
            <b-form-input id="input-1" v-model="search.code" placeholder="کد مشتری "></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2" label="نام مشتری: " label-for="input-2">
            <b-form-input id="input-2" v-model="search.name" placeholder="نام مشتری "></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-3" label="تلفن همراه مشتری: " label-for="input-3">
            <b-form-input id="input-3" v-model="search.mobile" placeholder="تلفن همراه مشتری "></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-4" label="ایمیل مشتری: " label-for="input-4">
            <b-form-input id="input-4" v-model="search.email" placeholder="ایمیل مشتری "></b-form-input>
        </b-form-group>
        <b-form-group id="is_fav-gr" label="مشتری ویژه:" label-for="is_fav">
            <b-form-select v-model="search.is_fav" :options="is_favs"></b-form-select>
        </b-form-group>
    </b-modal>
    <b-card title="لیست بازاریابی">
        <b-card-text>
            <b-button class="mt-3" variant="success" @click="addNew()">جدید</b-button>
            <b-button class="mt-3 ml-3" variant="success" v-b-modal.modal-1>جستجو</b-button>
            <b-table responsive style="width: 100%" striped hover show-empty empty-text="آیتمی جهت نمایش وجود ندارد" :fields="fields" :items="List">
                <template v-slot:cell(details)="row">
                    <span>
                        <b-link variant="success" :href="'#/CustomerDetail/' + row.item.id">&nbsp;&nbsp;جزییات&nbsp;</b-link>
                        |
                    </span>

                    <span>
                        <b-link variant="success" :href="'#/AddCustomer/' + row.item.id">&nbsp;&nbsp;ویرایش&nbsp;</b-link>
                    </span>

                </template>
            </b-table>
        </b-card-text>
    </b-card>
    <b-modal ref="delete-modal" ok-title="تایید" cancel-title="انصراف" @ok="handleOk" title="حذف">آیا مایل به حذف آیتم مورد نظر می باشید؟</b-modal>
</div>
</template>

<script>
import {
    SET_BREADCRUMB
} from "@/core/services/store/breadcrumbs.module";
import httpHelpoer from "@/helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
import persianDate from "../../helpers/persianDate";
import MDDropdown from "../../components/MDDropdown";
export default {
    name: "Customers",
    data: function () {
        return {
            List: [],
            fields: [{
                    key: "id",
                    label: "شماره"
                },
                {
                    key: "user_inserted_name",
                    label: "نام بازایاب"
                },
                {
                    key: "name",
                    label: "نام مشتری"
                },
                {
                    key: "mobile",
                    label: "موبایل مشتری"
                },
                {
                    key: "email",
                    label: "ایمیل"
                },
                {
                    key: "status",
                    label: "نوع مشتری"
                },
                {
                    key: "is_fav",
                    label: "مشتری ویژه"
                },

                {
                    key: "details",
                    label: "جزییات"
                }
            ],
            selected_item: 0,

            search: {
                mdid17_type: 0,
                code: null,
                name: null,
                mobile: null,
                email: null,
                is_fav: null
            },
            is_favs: [{
                    value: 0,
                    text: 'خیر'
                },
                {
                    value: 1,
                    text: 'بله'
                }
            ],
        };
    },
    components: {
        MDDropdown
    },
    created() {
        this.filterData();
    },
    methods: {
        addNew: function () {
            this.$router.push({
                name: "AddCustomer"
            });
        },
        handleOk: function () {
            httpHelpoer.getData("crmcustomer/" + this.selected_item).then(res => {
                console.log(res);
                if (res.success) {
                    //this.List.splice(this.List.indexOf(this.selected_item), 1);
                    this.filterData();
                }
            });
        },
        deletem: function (selectedItem) {
            this.selected_item = selectedItem;
            this.$refs["delete-modal"].show();
        },
        filterData: function () {
            var params = "";

            if (this.search.mdid17_type) {
                params += "&mdid17_type=" + this.search.mdid17_type;
            }
            if (this.search.code) {
                params += "&code=" + this.search.code;
            }
            if (this.search.name) {
                params += "&name=" + this.search.name;
            }
            if (this.search.mobile) {
                params += "&mobile=" + this.search.mobile;
            }
            if (this.search.email) {
                params += "&email=" + this.search.email;
            }
            if (this.search.is_fav == 1 || this.search.is_fav == 0 ) {
                params += "&is_fav=" + this.search.is_fav;
            }
            httpHelpoer.setAuth();
            console.log("crmcustomer?t=1" + params);
            httpHelpoer
                .getData("crmcustomer?t=1" + params)
                .then(res => {
                    this.List = res.result.data;
                    this.List = this.List.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            user_inserted_name: item.user_inserted.name,
                            mobile: item.mobile,
                            email: item.email,
                            status: item.customer_type.title,
                            mdid17_status: item.customer_type.id,
                            is_fav: item.is_fav == "1" ? "بله" : "خیر"
                            /*moment(item.created_at, 'YYYY-MM-DDTHH:mm:ss.ZZ').locale('fa').format('YYYY/MM/DD')*/
                        };
                    });
                    console.log(res);
                })
                .finally(() => {});
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [{
            title: "لیست بازاریابی"
        }]);
    }
};
</script>
